import Userback, { UserbackWidget } from "@userback/widget";

const USERBACK_ACCESS_TOKEN = "A-dcPt0AWvxCZjD5hMwgGF9xYyx";

interface User {
  id: string;
  info: { name?: string; email?: string };
}
let userbackInstance: UserbackWidget | null = null;
let initialization: Promise<UserbackWidget> | null = null;
let currentUser: User | null = null;

function applySession(userback: UserbackWidget): void {
  if (currentUser) {
    userback.identify(currentUser.id, currentUser.info);
    userback.show();
    return;
  }
  userback.hide();
}

export function getUserback(): UserbackWidget | null {
  return userbackInstance;
}

export function identifyUser(userId: string, userInfo: User["info"]): void {
  currentUser = { id: userId, info: userInfo };
  if (userbackInstance?.isLoaded()) {
    applySession(userbackInstance);
    return;
  }
  if (initialization) return;

  // The init promise resolves in on_init, before the launcher button exists.
  // show() has to wait for on_load, which runs after that button is created.
  initialization = Userback(USERBACK_ACCESS_TOKEN, {
    autohide: true,
    on_load() {
      userbackInstance = this as UserbackWidget;
      applySession(userbackInstance);
    },
  });
  void initialization
    .then((userback) => {
      userbackInstance = userback;
    })
    .catch((error) => {
      initialization = null;
      console.error("Failed to initialize Userback:", error);
    });
}

export function clearUserIdentification(): void {
  currentUser = null;
  if (userbackInstance?.isLoaded()) {
    userbackInstance.hide();
    userbackInstance.identify("anonymous", {});
  }
}
